import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
const ITEMS = [{
  emoji: '📕',
  title: 'La Biblia en Cómic completa en PDF',
  text: 'Más de 200 páginas a todo color, de Génesis a Apocalipsis.'
}, {
  emoji: '📱',
  title: 'Formato universal',
  text: 'Se lee en celular, tablet, computadora o Smart TV.'
}, {
  emoji: '🖨️',
  title: 'Permiso de impresión doméstica',
  text: 'Imprímela y encuadérnala para regalar (ideal abuelos).'
}, {
  emoji: '♾️',
  title: 'Acceso de por vida',
  text: 'Descárgala las veces que quieras, sin vencimiento.'
}];
export function WhatYouGetSection() {
  return <section className="w-full bg-cream" data-id="element-170" data-mp="2sqer2hgc1fkf">
      <div className="mx-auto max-w-6xl px-4 py-5 md:py-6" data-id="element-171" data-mp="2spc2whae9r87">
        <h2 className="mx-auto max-w-3xl text-center font-display text-3xl font-bold leading-tight text-deep-blue md:text-[40px]" data-id="element-172" data-mp="cyqwgsosjz4s">
          Todo esto llega a tu email en menos de{' '}
          <span className="mark-gold" data-id="element-173" data-mp="1r3dlst20alx9">2 minutos</span>
        </h2>

        <div className="mt-6 grid grid-cols-1 items-center gap-6 md:grid-cols-2" data-id="element-174" data-mp="1r356kuiev4iw">
          <motion.img initial={{
          opacity: 0,
          scale: 0.96
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} src="https://cdn.magicpatterns.com/uploads/7Z5tmMKuRKz1jTHUZwXgJY/mockup.png" alt="La Biblia en Cómic en tablet, celular e impresa" className="mx-auto w-full max-w-sm drop-shadow-2xl" data-id="element-175" data-mp="1w16o3b06uvs9" />

          <ul className="space-y-4" data-id="element-176" data-mp="1d9m95bszalxb">
            {ITEMS.map((item, i) => <motion.li key={item.title} initial={{
            opacity: 0,
            x: 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.45,
            delay: i * 0.08
          }} className="flex items-start gap-4 rounded-card border border-card-border bg-white p-4 shadow-soft" data-id="element-177" data-mp="1hcaj5mtfhyvv" data-mpi={i}>
                <span className="text-2xl" aria-hidden="true" data-id="element-178" data-mp="1wxc3b5e9l4ba">
                  {item.emoji}
                </span>
                <div data-id="element-179" data-mp="1rxpt74tqg46p">
                  <h3 className="font-display text-lg font-bold text-deep-blue" data-id="element-180" data-mp="26oglsf35f7av">
                    {item.title}
                  </h3>
                  <p className="text-[15px] text-ink/70" data-id="element-181" data-mp="21qoloxscoevl">{item.text}</p>
                </div>
              </motion.li>)}
          </ul>
        </div>

        <div className="mt-6" data-id="element-182" data-mp="1917ta04qcxzd">
          <CtaButton label="QUIERO MI BIBLIA EN CÓMIC" size="lg" data-id="element-183" data-mp="191zr7hlsv7st" />
        </div>
      </div>
    </section>;
}